export class UsuarioSucursal {

 public id:number;
 public email:string;
 public codigoConsorcio:string;
 public codigoSucursal:string;
 
}


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/usuario-sucursal.ts